import BaseHelper from './moment-base';
import moment from 'moment';

export default class Unix extends BaseHelper {
  compute([timestamp]) {
    super.compute(...arguments);
    return moment.unix(timestamp);
  }
}
